import { boolean, defineAction, number, object } from '~/prix'
import agentAvailabilityCheckAction from './agentAvailabilityCheck.action.json' with { type: 'json' }

const agentAvailabilityCheckDefinition = defineAction({
  ...agentAvailabilityCheckAction,
  userActivityLog: true,
  operation: 'read' as const,
  input: object({
    latitude: number(),
    longitude: number(),
  }),
  output: object({ available: boolean() }),
})

export default agentAvailabilityCheckDefinition
